import en from 'locales/en/recruiter/core.json';

import { registerRecruiterNamespace } from '../registry';

export const CORE_NS = registerRecruiterNamespace('core', en);
